import {
  createClientDropdown,
  createGroupTypeDropdown,
  HEALTH_PLAN_DROPDOWN,
  PLAN_TYPE_DROPDOWN,
  sortFilterDropdowns,
  TRANSFERRED_FROM_CLIENT_DROPDOWN,
  TRANSFERRED_FROM_DROPDOWN,
} from 'constants/filterConfigs';
import {
  END_DATE,
  HEALTH_PLAN_CLASSIFICATION,
  PLAN_TYPE_CLASSIFICATION,
  START_DATE,
  TRANSFERRED_FROM,
  TRANSFERRED_FROM_CLIENT,
} from 'constants/filterKeysConstants';
import GroupType from 'models/GroupType';

export const receivingGroupFilterKey = (groupType: GroupType) => groupType.camelCaseApiName;
export const receivingClientFilterKey = (groupType: GroupType) => `${groupType.camelCaseApiName}Client`;

export const filtersForGroupType = (
  filters: Record<string, any>,
  selectedGroupType: GroupType,
  predecessorFilterKey: string
): Record<string, any> => {
  const validKeys = [
    predecessorFilterKey,
    receivingClientFilterKey(selectedGroupType),
    receivingGroupFilterKey(selectedGroupType),
    HEALTH_PLAN_CLASSIFICATION,
    PLAN_TYPE_CLASSIFICATION,
    TRANSFERRED_FROM,
    TRANSFERRED_FROM_CLIENT,
    START_DATE,
    END_DATE,
  ];

  return Object.entries(filters).reduce(
    (acc, [key, val]) => (validKeys.includes(key) ? { ...acc, [key]: val } : acc),
    {} as Record<string, any>
  );
};

export const getFilterSections = (
  predecessorGroupType: GroupType | undefined,
  selectedGroupType: GroupType | undefined,
  predecessorFilterKey: string
) => {
  if (!predecessorGroupType || !selectedGroupType) return [];

  const groupTypeName = selectedGroupType.displayName;

  const predecessorGroupDropdown = createGroupTypeDropdown(predecessorGroupType, undefined, {
    placeholder: `Referring ${predecessorGroupType.displayName}`,
    name: predecessorFilterKey,
  });

  const providerClientDropdown = createClientDropdown(
    [selectedGroupType.id],
    `${groupTypeName} Company`,
    receivingClientFilterKey(selectedGroupType),
    { groupTypeType: 'provider' }
  );

  const groupDropdown = createGroupTypeDropdown(selectedGroupType, undefined, {
    placeholder: groupTypeName,
    name: receivingGroupFilterKey(selectedGroupType),
  });

  return [
    {
      filters: sortFilterDropdowns([
        predecessorGroupDropdown,
        providerClientDropdown,
        groupDropdown,
        HEALTH_PLAN_DROPDOWN,
        PLAN_TYPE_DROPDOWN,
      ]),
    },
  ];
};

export const getBusinessDevelopmentFilterSections = (
  predecessorGroupType: GroupType | undefined,
  selectedGroupType: GroupType | undefined,
  predecessorFilterKey: string
) => {
  const sections = getFilterSections(predecessorGroupType, selectedGroupType, predecessorFilterKey);
  if (!sections.length) return sections;

  const renamedFilters = sections[0].filters.map((filter) => {
    if (filter.name === predecessorFilterKey) {
      return { ...filter, placeholder: predecessorGroupType?.displayName ?? filter.placeholder };
    }
    if (filter.name === HEALTH_PLAN_CLASSIFICATION) {
      return { ...filter, placeholder: 'Payer Source' };
    }
    return filter;
  });

  return [
    {
      filters: sortFilterDropdowns([...renamedFilters, TRANSFERRED_FROM_DROPDOWN, TRANSFERRED_FROM_CLIENT_DROPDOWN]),
    },
  ];
};
